import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IDocument } from "@rentiohq/shared-frontend/dist/types/document.types";

export interface IExtraData {
  files?: File[];
  document?: IDocument;
  contracts?: IContract[];
  contractId?: string;
}

export enum EField {
  Name = "filename",
  Category = "categoryId",
  Contract = "contractId",
}
